module.exports = "/build/images/eraser.svg?43ff34dbc49d0440fb563c8184296221";


//////////////////
// WEBPACK FOOTER
// ./yii2/frontend/frontend-assets/src/_static/images/eraser.svg
// module id = 2256
// module chunks = 0